export default function withExcludeTagsCookie() {
    return async (ctx) => {
        const { cookies } = ctx;

        const {
            exclude_tags_override: [enableExcludeTagsOverride, { tagNames }],
        } = ctx.useFeatures([
            'exclude_tags_override',
        ]);

        // If the feature is enabled and there are tag names, set the cookie.  GTM uses this cookie in rules
        // to disable certain tags.
        if (enableExcludeTagsOverride) {
            if (tagNames.length > 0) {
                cookies.set('excludetags', tagNames);
            }
        }
    };
}
